import React, { useEffect } from 'react';

import Aos from 'aos';
import 'aos/dist/aos.css';
import CategoryTree from '../layouts/categoryTree';
import { motion } from "framer-motion";

const Accordion = ({categories,showCategory}) => {
 
   
    useEffect(()=>{
      Aos.init({duration:1000})
      
      },[])
 
 


  return (
    <motion.div initial={{ opacity: 0, x: -10 }}
    animate={{ opacity: 1, x: 0 }}
    exit={{ opacity: 0, x: -10 }}
    transition={{ duration: 0.3 }}  className=" rounded-md absolute left-[-66px]   top-[110%] lg:w-[180%] xl:w-[180%] sm:w-[480%] w-[480%]  pt-2 pl-0 pr-2  h-screen z-[80] bg-white  shadow-md ">
  
  <CategoryTree categories={categories} showCategory={showCategory}/>

    </motion.div>
  );
};

// Usage example:


export default Accordion;
